import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function FeaturedSection() {
  const byCategory: Record<string, typeof movies> = {};
  movies.forEach((m) => {
    if (!byCategory[m.category]) byCategory[m.category] = [];
    byCategory[m.category].push(m);
  });

  const categoryNames: Record<string, string> = {
    dianying: '热门电影',
    dianshiju: '热播剧集',
    dongman: '人气动漫',
    zongyi: '火爆综艺',
    jilupian: '高分纪录片',
  };

  const order = ['dianying', 'dianshiju', 'dongman'];

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {order.map((cat, idx) => {
          const items = (byCategory[cat] || []).slice(0, 4);
          if (items.length === 0) return null;
          return (
            <div key={cat} className={idx > 0 ? 'mt-12' : ''}>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-lg md:text-2xl font-bold text-foreground-900 font-heading">
                  {categoryNames[cat]}
                </h2>
                <a
                  href={`/category/${cat}`}
                  className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
                >
                  更多
                  <span className="w-4 h-4 inline-flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-sm"></i>
                  </span>
                </a>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {items.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}